import styled from 'styled-components';
import Container from './container';

export const MainContainer = styled(Container)`
	display: flex;
	gap: 21px;
`;
